<app-user-selector
    [settingsData]="data"
    (usersSelected)="usersSelected($event)"
    (selectionCanceled)="cancel()"></app-user-selector>
